<template>
    <div>
        <span class="data-label">
            <div class="ellipsis">{{ forceLabel ? forceLabel : label }}</div>
            <i
                v-if="useFavorite"
                :class="['blue ml-2 fs-2 cpointer data-label-icon-toggle', isFavoriteClass]"
                @click.prevent="toggleFavorite"
            ></i>
            <i
                v-if="canRemoveFavorite"
                class="icon-close primary-50 ml-2 fs-2 cpointer"
                @click.prevent="toggleFavorite"
            ></i>
        </span>
        <span :class="['data-value copy-element', canRemoveFavoriteClass]">
            <a :href="formatHref(value)" target="_blank" class="black-link semibold">
                {{ value }}
            </a>
            <SaasClipboard v-if="value" :data="value" />
        </span>
    </div>
</template>

<script>
import FavoriteHeaderMixins from '../../../../mixins/FavoriteHeaderMixins';
import DataValueMixin from '../../../../mixins/DataValueMixins';
import { prependHttpString } from 'utils/url';
import SaasClipboard from 'vcomponents/utilities/SaasClipboard.vue';

export default {
    components: {
        SaasClipboard,
    },
    mixins: [FavoriteHeaderMixins, DataValueMixin],
    methods: {
        formatHref: prependHttpString,
    },
};
</script>

<style scoped>
.data-label {
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>
